import QRCode from "react-qr-code";
import { Button } from "@/components/ui/button";
import { Download, Printer } from "lucide-react";

export const QRCodeDisplay = ({ scooterId, scooterName, size = 128 }) => {
  const appUrl = window.location.origin;
  const qrUrl = `${appUrl}/scooter/${scooterId}`;

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>QR Code - ${scooterName || scooterId}</title>
          <style>
            body {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              min-height: 100vh;
              margin: 0;
              font-family: monospace;
              background: white;
            }
            .container {
              text-align: center;
              padding: 20px;
            }
            h1 {
              font-size: 24px;
              margin-bottom: 8px;
              letter-spacing: 2px;
            }
            .scooter-name {
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 8px;
              font-family: Arial, sans-serif;
            }
            p {
              font-size: 12px;
              color: #666;
              margin-bottom: 24px;
            }
            .qr-wrapper {
              background: white;
              padding: 16px;
              border: 2px solid #000;
              display: inline-block;
            }
            .scooter-id {
              margin-top: 16px;
              font-size: 18px;
              font-weight: bold;
              letter-spacing: 2px;
            }
            .instructions {
              margin-top: 16px;
              font-size: 11px;
              color: #666;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <h1>SCUTERSH</h1>
            ${scooterName ? `<div class="scooter-name">${scooterName}</div>` : ''}
            <p>Scan for full scooter details / Scanează pentru detalii complete</p>
            <div class="qr-wrapper">
              ${document.getElementById(`qr-${scooterId}`).innerHTML}
            </div>
            <div class="scooter-id">${scooterId}</div>
            <div class="instructions">${qrUrl}</div>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  const handleDownload = () => {
    const svg = document.getElementById(`qr-${scooterId}`).querySelector("svg");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      
      const link = document.createElement("a");
      link.download = `qr-${scooterId}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    };
    
    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  return (
    <div className="flex flex-col items-center gap-4">
      {scooterName && (
        <p className="font-heading font-bold text-center text-lg">
          {scooterName}
        </p>
      )}
      <div 
        id={`qr-${scooterId}`}
        className="qr-container"
      >
        <QRCode
          value={qrUrl}
          size={size}
          level="H"
          bgColor="#FFFFFF"
          fgColor="#000000"
        />
      </div>
      <p className="font-mono text-sm font-bold text-center">
        {scooterId}
      </p>
      <p className="font-mono text-xs text-muted-foreground text-center break-all max-w-[200px]">
        {qrUrl}
      </p>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={handlePrint}
          data-testid="btn-print-qr"
        >
          <Printer className="w-4 h-4 mr-2" />
          Print
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={handleDownload}
          data-testid="btn-download-qr"
        >
          <Download className="w-4 h-4 mr-2" />
          Download
        </Button>
      </div>
    </div>
  );
};
